import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./NavMenu.css";
import { NavLink } from "react-router-dom";
const NavMenuVZY = () => {
  const location = useLocation();
  const [currentroute, setcurrentroute] = useState(location.pathname);
  useEffect(() => {
    setcurrentroute(location.pathname);
  }, [location]);

  return (
    <div className="NavMain">
      <nav
        className="navbar navbar-expand navbar-dark flex-column flex-md-row bd-navbar b-watcho"
        style={{ backgroundColor: "#1E1E1E" }}
      >
        <a className="navbar-brand mr-0 mr-md-2" href="https://vzy.one/en/home">
          <img src="/Images/logo.svg" className="b-logo" alt="VZY" />
        </a>

        <div className="navbar-nav-scroll">
          <ul className="navbar-nav bd-navbar-nav flex-row">
            {(currentroute === "/VZY/BecomeOurPartner" ||
              currentroute === "/VZY/family-and-friends") && (
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="https://vzy.one/en/home"
                  target="_blank"
                  rel="noreferrer"
                >
                  Home
                </a>
              </li>
            )}

            {(currentroute === "/VZY/BecomeOurPartner" ||
              currentroute === "/") && (
              <li className="nav-item">
                <NavLink
                  to="/VZY/BecomeOurPartner"
                  className={`nav-link ${
                    currentroute === "/VZY/BecomeOurPartner" ? "active-vzy" : ""
                  }`}
                >
                  Become our Partner
                </NavLink>
              </li>
            )}

            {(currentroute === "/VZY/family-and-friends" ||
              currentroute === "/") && (
              <li className="nav-item">
                <NavLink
                  to="/VZY/family-and-friends"
                  className={`nav-link ${
                    currentroute === "/VZY/family-and-friends"
                      ? "active-vzy"
                      : ""
                  }`}
                >
                  Family and Friends
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default NavMenuVZY;
